var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "voice-settings" }, [
    _c("h3", { staticClass: "settings-title" }, [_vm._v("Ses Ayarları")]),
    _vm._v(" "),
    _c("div", { staticClass: "settings-section" }, [
      _c("h4", { staticClass: "section-title" }, [_vm._v("Voice Model")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "voice-model-options" },
        _vm._l(_vm.voiceModels, function (model) {
          return _c(
            "div",
            {
              key: model.id,
              staticClass: "voice-model-option",
              class: { selected: _vm.localVoiceModel === model.id },
              on: {
                click: function ($event) {
                  return _vm.selectVoiceModel(model.id)
                },
              },
            },
            [
              _c("div", { staticClass: "radio-button" }, [
                _vm.localVoiceModel === model.id
                  ? _c("div", { staticClass: "radio-dot" })
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "model-info" }, [
                _c("div", { staticClass: "model-name" }, [
                  _vm._v(_vm._s(model.name)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "model-description" }, [
                  _vm._v(_vm._s(model.description)),
                ]),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "settings-section" },
      [
        _c("div", { staticClass: "slider-header" }, [
          _c("h4", { staticClass: "section-title" }, [
            _vm._v("Voice Temperature"),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.localVoiceTemperature.toFixed(2))),
          ]),
        ]),
        _vm._v(" "),
        _c("a-slider", {
          attrs: { min: 0, max: 2, step: 0.01 },
          model: {
            value: _vm.localVoiceTemperature,
            callback: function ($$v) {
              _vm.localVoiceTemperature = $$v
            },
            expression: "localVoiceTemperature",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "slider-description" }, [
          _vm._v(
            "\n            Düşük değer daha kararlı ses, yüksek değer daha değişken konuşma üretir. [0-2]\n        "
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "settings-section" },
      [
        _c("div", { staticClass: "slider-header" }, [
          _c("h4", { staticClass: "section-title" }, [_vm._v("Voice Speed")]),
          _vm._v(" "),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.localVoiceSpeed.toFixed(2))),
          ]),
        ]),
        _vm._v(" "),
        _c("a-slider", {
          attrs: { min: 0.5, max: 2, step: 0.01 },
          model: {
            value: _vm.localVoiceSpeed,
            callback: function ($$v) {
              _vm.localVoiceSpeed = $$v
            },
            expression: "localVoiceSpeed",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "slider-description" }, [
          _vm._v(
            "\n            Düşük değer daha yavaş konuşma, yüksek değer daha hızlı konuşma hızı. [0.5-2]\n        "
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "settings-section" },
      [
        _c("div", { staticClass: "slider-header" }, [
          _c("h4", { staticClass: "section-title" }, [_vm._v("Voice Volume")]),
          _vm._v(" "),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.localVoiceVolume.toFixed(2))),
          ]),
        ]),
        _vm._v(" "),
        _c("a-slider", {
          attrs: { min: 0, max: 2, step: 0.01 },
          model: {
            value: _vm.localVoiceVolume,
            callback: function ($$v) {
              _vm.localVoiceVolume = $$v
            },
            expression: "localVoiceVolume",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "slider-description" }, [
          _vm._v(
            "\n            Düşük değer daha sessiz konuşma, yüksek değer daha yüksek sesli konuşma. [0-2]\n        "
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "action-buttons" },
      [
        _c("a-button", { on: { click: _vm.resetSettings } }, [_vm._v("İptal")]),
        _vm._v(" "),
        _c(
          "PermissionController",
          { attrs: { permissions: ["voice-agent.update"] } },
          [
            _c(
              "a-button",
              { attrs: { type: "primary" }, on: { click: _vm.saveSettings } },
              [_vm._v("Kaydet")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }